import SectionHub from '@/components/docs/SectionHub';

export default function Docs00OverviewHub() {
  return <SectionHub sectionPath="00-overview" />;
}
